export class CurrencyService {
  getDefaultCurrency(currencies) {
    return currencies.find((item) => item.default)?.currency;
  }

  getDefaultCurrencySymbol(currencies) {
    return currencies.find((item) => item.default)?.symbol;
  }
}
